export const selectOptionsLoanProductType = [
  "DSCR",
  "Fix and Flip",
  "Ground Up Construction",
  "Multifamily Bridge",
  "Stabilized Bridge",
  "Other",
];
